
import { Config } from 'tradingmate-modules/src/environment'
import { CategoryModel } from 'tradingmate-modules/src/models/api/categorisation'
import { Services } from 'tradingmate-modules/src/services'
import { Component, Vue } from 'vue-property-decorator'
import NavigationLink from './NavigationLink.vue'

@Component({
  components: {
    NavigationLink
  }
})
export default class Footer extends Vue {
  private popularCategories: CategoryModel[] | null = null;
  private registerLink = Config.WebsiteUrls.Console + '/account/register'

  mounted (): void {
    this.getCategories();

    // Set up the CHAT2_API config
    (window as any).CHAT2_API = (window as any).CHAT2_API || {};
    (window as any).CHAT2_API.args = {
      mode: 'widget',
      chat2_base_url: '//tradingmatecomau.chat2.com/',
      wheight: 450,
      wwidth: 350,
      pheight: 520,
      pwidth: 500,
      leaveamessage: true,
      check_messages: false,
      lang: 'eng/'
    }

    // Dynamically create the <script> element
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.setAttribute('crossorigin', 'anonymous')
    script.async = true

    const date = new Date()
    script.src = `//tradingmatecomau.chat2.com/design/defaulttheme/js/widgetv2/index.js?${date.getFullYear()}${date.getMonth()}${date.getDate()}`

    const firstScript = document.getElementsByTagName('script')[0]
    if (firstScript.parentNode) {
      firstScript.parentNode.insertBefore(script, firstScript)
    }
  }

  getCategories (): void {
    Services.API.Categories.GetPopular(5).then((returnCategories) => {
      this.popularCategories = returnCategories
    })
  }

  private Config = Config
}
